export const APP_NAME = process.env.REACT_APP_APP_NAME || 'Luminary';
export const APP_VERSION = process.env.REACT_APP_VERSION || '1.0.0';
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';
export const ENV = process.env.REACT_APP_ENV || 'development';

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'luminary_auth_token',
  USER: 'luminary_user',
};

export const THEME_COLORS = {
  primary: '#0A0A0F',
  accent: '#C8FF00',
  surface: '#13131A',
  border: '#2A2A38',
};
